<template>
  <a-modal v-model="visible" title="编辑活动信息" width="50%" @ok="doSubmit" @cancel="close" centered destroyOnClose
    :confirmLoading="loading">
    <a-form-model ref="formRef" :model="formData" label-position="top">
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="活动标题" label-position="top" prop="title"
            :rules="{ required: true, message: '请输入活动标题' }">
            <a-input v-model="formData.title" placeholder="请输入活动标题" />
          </a-form-model-item>
        </a-col>
        <a-col :span="3">
          <a-form-model-item label="限领数量" label-position="top" prop="userLimit"
            :rules="{ required: true, message: '请填写单用户领取数量' }">
            <a-input-number v-model="formData.userLimit" :min="1" :max="100" placeholder="单用户限领数量" style="width:100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="3">
          <a-form-model-item label="活动总数量" label-position="top" prop="totalLimit"
            :rules="{ required: true, message: '请填写活动总发放数量' }">
            <a-input-number v-model="formData.totalLimit" :min="1" placeholder="发放总数量" style="width:100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="状态" prop="status">
            <a-radio-group v-model="formData.status" button-style="solid" style="width: 100%;">
              <a-radio-button value="未发布">不发布</a-radio-button>
              <a-radio-button value="进行中">进行中</a-radio-button>
              <a-radio-button value="已结束">已结束</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="6">
          <a-form-model-item label="活动开始时间" label-position="top" prop="startTime"
            :rules="{ required: true, message: '请选择活动开始时间' }">
            <a-date-picker valueFormat="YYYY-MM-DD HH:mm" v-model="formData.startTime" showTime style="width:100%"
              allowClear format="YYYY-MM-DD HH:mm" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="活动截止时间" label-position="top" prop="overTime"
            :rules="{ required: true, message: '请选择活动截止时间' }">
            <a-date-picker valueFormat="YYYY-MM-DD HH:mm" v-model="formData.overTime" showTime style="width:100%"
              allowClear format="YYYY-MM-DD HH:mm" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="管理单位" label-position="top" prop="organId"
            :rules="{ required: true, message: '请选择管理单位' }">
            <choose-organ v-model="formData.organId"></choose-organ>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="可用商户范围" prop="scopeIds" help="不选择表示所有商户可用">
            <choose-store v-model="formData.scopeIds" multiple></choose-store>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="4">
          <a-form-model-item label="奖品类型" prop="couponType" :rules="{ required: true, message: '请选择奖品类型' }">
            <a-select v-model="formData.couponType" placeholder="请选择奖品类型">
              <a-select-option v-for="(item, index) in couponType" :value="item.label" :key="index"
                v-if="item.type != '实物'">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="面值" prop="money"
            :rules="{ required: !['折扣券', '礼品'].includes(formData.couponType), message: '请填写面值' }">
            <a-input-number placeholder="面值" :disabled="['折扣券', '礼品'].includes(formData.couponType)"
              v-model="formData.money" style="width:100%"></a-input-number>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="折扣" prop="discount" help="1-99之间的数字"
            :rules="{ required: ['折扣券'].includes(formData.couponType), message: '请填写折扣' }">
            <a-space>
              <a-input-number placeholder="最大99" :disabled="!['折扣券'].includes(formData.couponType)"
                v-model="formData.discount" :max="99" :min="1" style="width:100%">
              </a-input-number>
              <span>折</span>
            </a-space>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="使用条件" prop="fullMoney" help="实付金额满多少可用"
            :rules="{ required: !['礼品'].includes(formData.couponType), message: '请填写使用条件' }">
            <a-input-number placeholder="满多少可用" :disabled="['礼品'].includes(formData.couponType)"
              v-model="formData.fullMoney" :min="0" style="width:100%"></a-input-number>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="商家出资比例(%)" prop="storeFee" :rules="{ required: true, message: '请填写商家出资比例' }">
            <a-input-number placeholder="出资比例" v-model="formData.storeFee" style="width:100%" :max="100"
              :min="0"></a-input-number>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="有效天数(天)" prop="expireDay" help="从领取后开始计算"
            :rules="{ required: true, message: '请填写有效天数' }">
            <a-input-number placeholder="有效天数" v-model="formData.expireDay" style="width:100%"
              :min="1"></a-input-number>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="活动概要" prop="description">
            <a-textarea v-model="formData.description"></a-textarea>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="" label-position="top" prop="thumb" :rules="{ required: true, message: '请上传商品图片' }">
            <upload-images v-model="formData.thumb" :size="3"></upload-images>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="活动详情" prop="content" label-position="top">
            <editor v-model="formData.content" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import apiUtils from '@/common/apiUtil';
import { GOODS_TYPE, COUPON_TYPE } from '@/common/gradeGoods'
import request, { editorUpload } from "@/config/request";
import editor from '@/components/component/editor.vue';
import uploadImages from '@/components/upload-images.vue'
import chooseStore from '@/components/choose-store.vue'
import utils from '@/common/utils';
export default {
  components: { editor, uploadImages, chooseStore },
  data() {
    return {
      visible: false,
      couponType: COUPON_TYPE,
      loading: false,
      formData: {
        activeId: '',
        title: '',
        thumb: [],
        description: '',
        content: '',
        startTime: '',
        overTime: '',
        couponType: '',
        money: '',
        fullMoney: '',
        discount: '',
        expireDay: 365,
        userLimit: 1,
        totalLimit: 0,
        storeFee: 100,
        organId: apiUtils.getDefaultOrganId(),
        scopeIds: '',
        status: '已发布'
      }
    }
  },
  methods: {
    doSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          return;
        }
        this.loading = true;
        request.post('/platform/coupon/active/save', this.formData).then(res => {
          // console.log(res)
          utils.success('保存成功').then(() => {
            this.$emit('success');
            this.close();
          })
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    close() {
      this.formData.activeId = '';
      this.$refs.formRef.resetFields();
      this.visible = false;
    },
    show(data) {
      this.visible = true;
      this.formData.activeId = '';
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
        this.$refs.formRef.resetFields();
        if (data) {
          this.formData = JSON.parse(JSON.stringify(data));
        }
      })
    }
  }
}
</script>

<style></style>